import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'

import Icon from 'Pods/Shared/Icon/Icon'

import UploadingGuidelines from './UploadingGuidelines'
import ChooseDraftModelModal from './Modals/ChooseDraftModelModal'

class UploadArea extends React.Component {
  constructor() {
    super()

    this.state = {
      guidelinesAreOpen: !sessionStorage.getItem('publisherGuidelinesClosed'),
      modalChooseDraftIsOpen: false,
    }

    this.triggerGuidelines = this.triggerGuidelines.bind(this)
    this.openChooseDraftModal = this.openChooseDraftModal.bind(this)
    this.closeChooseDraftModal = this.closeChooseDraftModal.bind(this)
    this.chooseDraftModel = this.chooseDraftModel.bind(this)
    this.dropzoneRef = React.createRef()
    this.openFileDialog = this.openFileDialog.bind(this)
  }

  openFileDialog() {
    if (this.dropzoneRef.current) {
      this.dropzoneRef.current.open()
    }
  }

  triggerGuidelines(isOpen) {
    sessionStorage.setItem('publisherGuidelinesClosed', 'true')
    this.setState({ guidelinesAreOpen: isOpen })
  }

  openChooseDraftModal() {
    this.setState({ modalChooseDraftIsOpen: true })
  }

  closeChooseDraftModal() {
    this.setState({ modalChooseDraftIsOpen: false })
  }

  chooseDraftModel(id) {
    const { onDraftChoose } = this.props
    this.closeChooseDraftModal()
    onDraftChoose(id)
  }

  render() {
    const { guidelinesAreOpen, modalChooseDraftIsOpen } = this.state
    const {
      modelId,
      onDrop,
      otherDraftsCount,
      isImageUploadMode,
      onFileDialogClose,
    } = this.props

    return (
      <div className="publisher-area publisher-area--upload">
        <div className="card">
          <div className="l-inner">
            <div className="row">
              <div
                className={`col-12 ${
                  guidelinesAreOpen
                    ? 'col-md-5 col-lg-6 col-xl-7'
                    : 'dropzone--full-width'
                }`}
              >
                <div className="upload-area__heading">
                  <div className="section-heading section-heading--not-spaced">
                    Upload files
                  </div>
                  {otherDraftsCount >= 1 && (
                    <span
                      className="choose-draft__open u-ml10"
                      onClick={() => this.openChooseDraftModal()}
                    >
                      or choose one of your drafts
                    </span>
                  )}
                  {!guidelinesAreOpen && (
                    <span
                      className="guidelines__trigger"
                      onClick={() => this.triggerGuidelines(true)}
                    >
                      <Icon
                        type={['far', 'chevron-left']}
                        className="height-12"
                      />{' '}
                      Uploading guidelines
                    </span>
                  )}
                </div>

                {modalChooseDraftIsOpen && (
                  <ChooseDraftModelModal
                    modelId={modelId}
                    modalIsOpen={modalChooseDraftIsOpen}
                    closeModal={this.closeChooseDraftModal}
                    chooseModel={this.chooseDraftModel}
                  />
                )}

                <div className="dropzone-container--grey">
                  <Dropzone
                    ref={this.dropzoneRef}
                    className="drop-area"
                    onDrop={onDrop}
                    onFileDialogCancel={onFileDialogClose}
                    accept={
                      isImageUploadMode ? 'image/png,image/jpeg' : undefined
                    }
                  >
                    <div className="drop-area__text">
                      Drag & Drop files here or
                      <span className="btn btn-fat btn-primary u-ml10">
                        Browse
                      </span>
                    </div>
                    <Icon type={['fal', 'upload']} notSpaced />
                  </Dropzone>
                </div>
              </div>

              {guidelinesAreOpen && (
                <UploadingGuidelines
                  triggerGuidelines={this.triggerGuidelines}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

UploadArea.propTypes = {
  modelId: PropTypes.string.isRequired,
  onDrop: PropTypes.func.isRequired,
  onDraftChoose: PropTypes.func.isRequired,
  otherDraftsCount: PropTypes.number.isRequired,
  isImageUploadMode: PropTypes.bool.isRequired,
  onFileDialogClose: PropTypes.func.isRequired,
}

export default UploadArea
